import React, {useState} from 'react';
import {Formik, Field, FormikProps} from 'formik';
import {useHistory} from 'react-router-dom';

import {Form, Button, Modal, Popup, PopupMessage} from '@components';
import paths from '@paths';
import constants from '@constants';
import validate from '@validations';
import {Props} from './types';
import * as handlers from './handlers';

import './index.scss';

const Leave: React.FC<Props> = props => {
  const [isModal, setIsModal] = useState(false);
  const [isFaildModal, setIsFaildModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const initialValues = {
    locked: false,
    group: false,
    // 無料プランではチェックボックスを表示させない為、初期値をtrueにする
    charging: props.me.plan === constants.PLAN.FREE ? true : false,
  };

  return (
    <div className="a__mypage-leave">
      <div className="b__title">
        <Button.GoBack history={props.history} />
        退会
      </div>
      <div className="w__field-flex">
        <div className="w__leave-field">
          <div className="w__leave-message">
            <div className="bold">退会時の注意事項</div>
            <div className="w__alert">
              退会前に以下の内容をご確認頂き、チェックをしてください。
              <Form.Label text="" required />
            </div>
          </div>
          <Formik
            initialValues={initialValues}
            validate={validate.leave.main}
            onSubmit={() => {
              setIsModal(true);
            }}
          >
            {(formProps: FormikProps<any>) => {
              return (
                <>
                  <div className="w__input">
                    <Field
                      name="locked"
                      component={Form.Checkbox}
                      label="AnpiCheckerへのログインができなくなります。"
                    />
                  </div>
                  <div className="w__input">
                    <Field
                      name="group"
                      component={Form.Checkbox}
                      label="登録した一般ユーザー・管理者が全て削除されます。"
                    />
                  </div>
                  {props.me.plan !== constants.PLAN.FREE && (
                    <div className="w__input">
                      <Field
                        name="charging"
                        component={Form.Checkbox}
                        label="退会と同時に請求が発生します。"
                      />
                    </div>
                  )}

                  <div className="w__button">
                    <Button.Normal
                      text="退会する"
                      color="yellow"
                      disabled={props.me.isForceCanceled}
                      onClick={() => formProps.handleSubmit()}
                    />
                    {props.me.isForceCanceled && (
                      <Popup.Normal
                        content={<PopupMessage.FaildCharging leaving />}
                        on="click"
                        basic
                      />
                    )}
                  </div>
                </>
              );
            }}
          </Formik>
        </div>
      </div>
      <Modal.Delete
        isModal={isModal}
        handleCloseModal={setIsModal}
        confirmText="退会する"
        title="AnpiCheckerから退会"
        onClick={() => {
          handlers.leave(props.me, setLoading, setIsModal, setIsFaildModal);
        }}
        loading={loading}
        disabled={loading}
        message={
          <>
            <div>退会してもよろしいですか？</div>
          </>
        }
      />
      <Modal.Normal
        title="決済の失敗"
        size="xs"
        isModal={isFaildModal}
        message="決済に失敗した為退会できませんでした。カード変更後、再度退会処理をお願いします。"
        handleCloseModal={setIsModal}
        isAutoClose={false}
        hideCloseIcon
        buttonColor="yellow"
        buttonText="カードを変更する"
        hiddenCancelButton
        onClick={() => {
          history.push(paths.myPage.card);
          props.actions.me.updateMe();
        }}
      />
    </div>
  );
};

export default Leave;
